'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const fe=require('../../../dist-es6/shared/extensions/fatigueExtensions');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');let

RasterizationService=function(_BaseService){_inherits(RasterizationService,_BaseService);_createClass(RasterizationService,null,[{key:'$inject',get:function()
{return['dateService']}}]);

function RasterizationService(dateService){_classCallCheck(this,RasterizationService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._dateService=dateService;return _this;
}RasterizationService.prototype.

rasterize=function rasterize(schedule,overallInterval,period,timeZone){var _this2=this;
const schedulePeriods=overallInterval.getSpanningIntervals(period,1,timeZone);
const intervalsFilter=function(intervals,schedulePeriod){return intervals.filter(function(interval){return interval.intersects(schedulePeriod)})};

return schedulePeriods.map(function(schedulePeriod,index){
const filtered={};

for(const series of['duties','trips','sleep','sleepPromotingIntervals']){
filtered[series]=intervalsFilter(schedule[series],schedulePeriod);
}

for(const series of['fatigue','incidents']){
filtered[series]=schedule[series].filter(function(p){return schedulePeriod.contains(p.time)});
}

const nonAbutingSchedulePeriod=TimeInterval.from(schedulePeriod.start).to(schedulePeriod.end.getTime()-1);
const dutyPeriodsIncludingForecast=TimeInterval.clip(filtered.duties.concat(schedule.forecastDutyInterval||[])).to(nonAbutingSchedulePeriod);
const peakFatigue=fe(filtered.fatigue).peakConsistentWithFatigueApi(dutyPeriodsIncludingForecast);
if(peakFatigue&&schedule.forecastDutyInterval&&schedule.forecastDutyInterval.contains(peakFatigue.time)){
peakFatigue.forecasted=!0;
}

return _.assign({
interval:schedulePeriod,
peakFatigue:peakFatigue,
effectiveStatus:schedule.dailyEffectiveStatuses[index],
containsNow:schedulePeriod.contains(_this2._dateService.now())},
filtered);
});
};return RasterizationService}(BaseService);


module.exports=RasterizationService;
//# sourceMappingURL=rasterizationService.js.map
